import React from 'react';
import { List, ListItem, Box, Grid, IconButton, ListItemText, ListItemSecondaryAction } from '@mui/material';
import TrainingCard from './TrainingCard';
import {  ContentCopy } from '@mui/icons-material';

const TrainingList = ({ trainings, handleEdit, handleDelete, handleDuplicate }) => {
    return (
        <List>
            <Grid container spacing={2} >
                {trainings.map((training) => (
                    <Grid item md={4} key={training.id}>
                        <TrainingCard training={training} handleEdit={handleEdit} handleDelete={handleDelete} />
                        <ListItemSecondaryAction>
                          <IconButton onClick={() => handleDuplicate(training)}>
                             <ContentCopy/>
                            </IconButton>
                          </ListItemSecondaryAction>
                     </Grid>
                ))}
            </Grid>
            {trainings.length === 0 && <Box textAlign='center'>No hay entrenamientos creados</Box>}
        </List>
    );
};

export default TrainingList;